export default __webpack_public_path__ + "static/media/Path3454.b9b8e16f.svg";